import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Form, FormGroup, Col, Row, Button, InputGroup, Badge } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons'

import './style.scss';
import constants from '../../../util/constants'
import classHelper from '../../../util/class.helper'
import NPSpinnerModal from '../../../NPSpinnerModal';
import NPPanel from '../../../NPPanel';
import LoadingSpinner from '../../../LoadingSpinner';
import GrantsModules from '../../Roles/GrantsModules';
import ConfirmationModal from '../../Roles/ConfirmationModal';
import * as Grants from '../../../util/grants';
import { hasGrant } from '../../../util/grantHelper';

const { API_BASE_URL } = constants;

class UserGrants extends React.Component {
    constructor(props) {
        super(props);

        this.notOkToSave = this.notOkToSave.bind(this);
        this.actionSaveUserGrants = this.actionSaveUserGrants.bind(this);
        this.toggleUserCopySelect = this.toggleUserCopySelect.bind(this);
        this.toggleState = this.toggleState.bind(this);
        this.toggleRoleGrant = this.toggleRoleGrant.bind(this);
        this.toggleModalConfirmation = this.toggleModalConfirmation.bind(this);
        this.actionRefreshUser = this.actionRefreshUser.bind(this);

        this.state = {
            selectedRole: null,
            selectedRoles: [],
            selectableRoles: [],

            userCcrs: [],
            selectedCcr: null,

            selectedUser: null,
            selectableUsers: [],
            selectedUserCcrs: null,
            selectableUsersCcrs: [],

            selectableGrantModules: [],

            userAddedGrants: [],
            selectedGrants: [],
            prevUserGrants: [],

            allUserGrants: [],
            allUserRoles: [],

            roleId: null,
            success: null,
            error: null,
            roleasAreNotUpdated: true,
            confirmationModalShow: false,
        }

        this.axiosCancelSource = axios.CancelToken.source();
        this.apiOptions = { headers: props.header, cancelToken: this.axiosCancelSource.token };
    }

    componentDidMount() {
        axios.get(API_BASE_URL + 'Role/GetRoles', this.apiOptions)
            .then(response => {
                this.setState({
                    selectableRoles: response.data.AvailableRoles.map(role => ({
                        value: role,
                        label: role.Name
                    })),
                    selectableGrantModules: response.data.Modules
                });
            })

        axios.get(API_BASE_URL + 'Admin/GetUsers', this.apiOptions)
            .then(response => {
                this.setState({
                    selectableUsers: response.data.map(user => ({
                        value: user,
                        label: `${user.UserName}`
                    })),
                });
            });

        this.setState({
            userCcrs: this.props.user.ClientCodeRegional.map(ccr => ({
                value: ccr,
                label: ccr
            })),
            allUserGrants: [...this.props.user.Grants],
            allUserRoles: [...this.props.user.Roles]
        }, () => {
            // Only load grants and roles if a user dont have specified ccrs
            if (this.state.userCcrs.length > 0) {
                this.setState({ error: "Agent must have a selected Client Code Regional." })
                return
            }

            this.setState({
                selectedRoles: [...this.props.user.Roles],
                selectedGrants: [...this.props.user.Grants],
                prevUserGrants: [...this.props.user.Grants]
            });
        });
    }

    notOkToSave() {
        if (this.state.userCcrs.length > 0)
            if (this.state.selectedCcr == null)
                return true;

        return false;
    }

    toggleModalConfirmation() {
        this.setState(prevState => {
            return {
                ...prevState,
                confirmationModalShow: !prevState.confirmationModalShow
            }
        });
    }

    toggleUserCcr(item) {
        if (item)
            this.setState({ error: null })
        else
            this.setState({ error: "Agent must have a selected Client Code Regional." })

        this.setState({
            selectedCcr: item ? item : null
        }, () => {
            // map correct grants for the specified user ccr
            if (item == null) {
                this.setState({
                    selectedRoles: [],
                    selectedGrants: [],
                    prevUserGrants: []
                });
                return
            };

            //let ccrGrants = [...this.props.user.Grants].filter(x => x.ClientCode == item.value);
            //let ccrRoles = [...this.props.user.Roles].filter(r => ccrGrants.some(g => g.RoleId == r.RoleId));
            let ccrGrants = [...this.state.allUserGrants].filter(x => x.ClientCode == item.value);
            let ccrRoles = [...this.state.allUserRoles].filter(r => ccrGrants.some(g => g.RoleId == r.RoleId));

            this.setState({
                selectedRoles: [...ccrRoles],
                selectedGrants: [...ccrGrants],
                prevUserGrants: [...ccrGrants]
            });
        })
    }

    toggleUserCopySelect(item) {
        if (item?.value?.ClientCodeRegional?.length > 0)
            this.setState({
                selectedUser: item ? item : null,
                selectableUsersCcrs: [...item.value.ClientCodeRegional].map(ccr => ({
                    value: ccr,
                    label: ccr
                })),
                selectedUserCcrs: null
            })
        else
            this.setState({
                selectedUser: item ? item : null,
                selectableUsersCcrs: [],
                selectedUserCcrs: null
            })

    }

    toggleState(state, item) {
        this.setState({
            [state]: item ? item : null
        })
    }

    toggleRoleGrant(event, grant) {
        if (this.state.selectedGrants?.some(g => g.Type == grant.Type)) {
            // Grant exists - remove
            let _selectedGrants = this.state.selectedGrants;
            let indexArr = this.state.selectedGrants.map((_grant, index) => _grant.Type === grant.Type ? index : '').filter(String)
            if (indexArr != null) {
                for (let i = indexArr.length - 1; i >= 0; i--)
                    _selectedGrants.splice(indexArr[i], 1)

                this.setState({
                    selectedGrants: _selectedGrants
                })
            }
        }
        else {
            // Grant does not exist - add
            this.setState({
                selectedGrants: [...this.state.selectedGrants, grant]
            })
        }
    }

    actionSaveUserGrants() {
        let userRoleWrapper = {
            UserId: this.props.user.Id,
            ClientCode: this.state.selectedCcr?.value + "",
            UserGrants: this.state.selectedGrants,
            SelectedRoles: this.state.selectedRoles
        }

        axios.post(API_BASE_URL + 'Role/SaveUserGrants', userRoleWrapper, this.apiOptions)
            .then(response => {
                this.actionRefreshUser(userRoleWrapper.UserId);
                this.setState({
                    success: true,
                    confirmationModalShow: false
                }, () => setTimeout(() => { this.setState({ success: false }) }, 2000))
            })
            .catch(err => {
                this.setState({
                    error: true,
                    confirmationModalShow: false
                }, () => setTimeout(() => { this.setState({ error: false }) }, 2000))
            })
    }

    actionToggleRole(role) {
        if (role == null) return;
        if (role.value)
            role = role.value;

        if (this.state.selectedRoles.some(r => r.RoleId == role.RoleId)) {
            let index = this.state.selectedRoles.findIndex(r => r.RoleId == role.RoleId);
            if (index != null) {
                let _selectedRoles = this.state.selectedRoles;
                _selectedRoles.splice(index, 1);
                this.setState({
                    selectedRoles: _selectedRoles,
                    selectedRole: null
                })
            }

            // Filter which grants in selectedGrants that are not from the removed role, and keep them,
            // Grants that have the same RoleId as the removed role is not included in the new list.
            let _selectedRoleGrants = this.state.selectedGrants.filter(function (grant) {
                if (role.Grants?.some(g => g.RoleId === grant.RoleId) == false) {
                    return grant;
                }
            })

            this.setState({
                selectedGrants: [..._selectedRoleGrants]
            });
        }
        else {
            this.setState({
                selectedRoles: [...this.state.selectedRoles, role],
                selectedGrants: [...this.state.selectedGrants, ...role.Grants]
            })
        }
    }

    actionToggleUserCopy(user) {
        if (user == null) return;
        if (user.value)
            user = user.value;

        axios.get(`${API_BASE_URL}Admin/GetUser?id=${user.Id}`, this.apiOptions)
            .then(response => {
                let ccr = this.state.selectedUserCcrs?.value;
                if (ccr) {
                    // Copy from user client code regional
                    let ccrGrants = response.data.Grants?.filter(x => x.ClientCode == ccr);
                    let ccrRoles = response.data.Roles?.filter(r => ccrGrants.some(g => g.RoleId == r.RoleId));
                    let ccrRoleGrants = ccrGrants.filter(g => g.RoleId != null);

                    this.setState({
                        selectedRoles: [...ccrRoles],
                        selectedGrants: [...ccrGrants]
                    });
                    // addeing prevUserGrants: [...ccrRoleGrants] to above setState
                    // makes it so that removing from the copyed role grants marks
                    // them as removed in the confirmation window. 
                    // This though prevents the confirmation window from showing the
                    // new grants as added grants (because they are set as prevUserGrants).
                }
                else {
                    // Copy from regular user
                    this.setState({
                        selectedRoles: response.data.Roles ? [...response.data.Roles] : [],
                        selectedGrants: response.data.Grants ? [...response.data.Grants] : [],
                        prevUserGrants: []
                    });
                }
            });
    }

    actionRefreshUser(userId) {
        axios.get(`${API_BASE_URL}Admin/GetUser?id=${userId}`, this.apiOptions)
            .then(response => {
                if (this.props.user.ClientCodeRegional?.length > 0) {

                    let ccr = this.state.selectedCcr?.value || null;
                    if (ccr == null) return;

                    let ccrGrants = [...response.data.Grants].filter(x => x.ClientCode == ccr);
                    let ccrRoles = [...response.data.Roles].filter(r => ccrGrants.some(g => g.RoleId == r.RoleId));
                    let ccrRoleGrants = ccrGrants.filter(g => g.RoleId != null);

                    this.setState({
                        selectedRoles: [...ccrRoles],
                        selectedGrants: [...ccrGrants],
                        prevUserGrants: [...ccrGrants],

                        allUserGrants: response.data.Grants,
                        allUserRoles: response.data.Roles
                    });
                }
                else {
                    this.setState({
                        selectedRoles: [...response.data.Roles],
                        selectedGrants: [...response.data.Grants],
                        prevUserGrants: [...response.data.Grants]
                    });
                }
            });
    }

    render() {
        let roleGrants = [];
        let activeGrants = this.state.selectedGrants;
        let addedGrants = this.state.userAddedGrants;
        let editable = hasGrant(Grants.TYPES.Admin_ManageUserRoles);

        this.state.selectedRoles.forEach(role => roleGrants.push(...role.Grants));
        activeGrants = activeGrants.concat(addedGrants);  // Push the manually added grants to activeGrants

        let changed = {
            valueContainer: (provided) => ({
                ...provided,
                minWidth: '160px',
                backgroundColor: this.state.selectedCcr ? 'white' : 'lightpink',
                marginLeft: this.state.selectedCcr ? '0px' : '2px'
            })
        };

        return (
            <NPPanel>
                <Dialog ref={(el) => { this.dialog = el }} />
                <NPSpinnerModal showModal={this.state.showSpinnerModal} title="saving" content={this.state.modalContent} closeAction={this.close} isLoading={this.state.saveInProgress} />

                <Row>
                    <Form inline onSubmit={evt => { evt.preventDefault(); }}>

                        {this.state.userCcrs.length > 0 &&
                            <Col md={12} lg={12} className="margin-top-10" >
                                <fieldset className="myfieldset smaller-inputs margin-top-10">
                                    <legend className="mylegend">Client Code Regional</legend>

                                    <FormGroup className="select margin-top-10">
                                        <InputGroup>
                                            <span className="input-group-addon">CCR</span>
                                            <Select style={{backgroundColor: 'red'}} placeholder="Select user CCR"
                                                styles={changed}
                                                isClearable={true}
                                                options={this.state.userCcrs}
                                                menuContainerStyle={{ zIndex: 5 }}
                                                value={this.state.selectedCcr}
                                                onChange={(item) => this.toggleUserCcr(item)} />
                                        </InputGroup>

                                    </FormGroup>
                                </fieldset>
                            </Col>
                        }

                        <Col md={12} lg={12} className="margin-top-10">
                            <fieldset className="myfieldset smaller-inputs">
                                <legend className="mylegend">Copy from user</legend>

                                <FormGroup className="select margin-top-10">
                                    {editable &&
                                        <InputGroup>
                                            <span className="input-group-addon">User</span>
                                            <Select placeholder="Select user to copy from"
                                                styles={classHelper.dropdownStyleLarge()}
                                                isClearable={true}
                                                options={this.state.selectableUsers}
                                                menuContainerStyle={{ zIndex: 5 }}
                                                value={this.state.selectedUser}
                                                onChange={(item) => this.toggleUserCopySelect(item)} />
                                        </InputGroup>
                                    }

                                    {this.state.selectableUsersCcrs.length > 0 &&
                                        <InputGroup className="margin-left-20">
                                            <Select placeholder="Select user ccr"
                                                styles={classHelper.dropdownStyleMedium()}
                                                isClearable={true}
                                                options={this.state.selectableUsersCcrs}
                                                menuContainerStyle={{ zIndex: 5 }}
                                                value={this.state.selectedUserCcrs}
                                                onChange={(item) => this.toggleState("selectedUserCcrs", item)} />
                                        </InputGroup>
                                    }
                                    {editable &&
                                        <Button bsStyle="primary" className="btn-sm margin-left-10" onClick={evt => { this.actionToggleUserCopy(this.state.selectedUser) }}>
                                            Copy roles and grants
                                    </Button>
                                    }
                                </FormGroup>
                            </fieldset>
                        </Col>


                        <Col md={12} lg={12} className="margin-top-10">
                            <fieldset className="myfieldset smaller-inputs">
                                <legend className="mylegend">Roles</legend>
                                {editable &&
                                    <FormGroup className="select margin-top-10">
                                        <InputGroup>
                                            <span className="input-group-addon">Role</span>
                                            <Select placeholder="Select role to add"
                                                styles={classHelper.dropdownStyleLarge()}
                                                isClearable={true}
                                                options={this.state.selectableRoles}
                                                menuContainerStyle={{ zIndex: 5 }}
                                                value={this.state.selectedRole}
                                                onChange={(item) => this.toggleState("selectedRole", item)} />
                                        </InputGroup>

                                        <Button bsStyle="primary" className="btn-sm margin-left-10" onClick={evt => this.actionToggleRole(this.state.selectedRole)}>
                                            Add selected role
                                        </Button>
                                    </FormGroup>
                                }
                                <span className="roleBadges margin-left-20">
                                    {this.state.selectedRoles.map(role => <Badge variant="light" key={role.RoleId} onClick={() => { if (editable) this.actionToggleRole(role) }}>{role.Name}<FontAwesomeIcon icon={faTimes} /></Badge>)}
                                </span>
                            </fieldset>
                        </Col>

                        <Col md={12} lg={12} className="margin-top-10" >
                            <GrantsModules selectableGrantModules={this.state.selectableGrantModules}
                                roleGrants={roleGrants}
                                activeGrants={activeGrants}
                                toggleRoleGrant={this.toggleRoleGrant}
                                disabled={hasGrant(Grants.TYPES.Admin_ManageUserRoles) === false} />
                        </Col>

                        <Col sm={12}>
                            {this.state.success &&
                                <div>
                                    <label><FontAwesomeIcon icon={faCheck} /> Success!</label>
                                </div>
                            }
                            {this.state.error &&
                                <div>
                                    <label className="danger"><FontAwesomeIcon icon={faTimes} /> Error: {this.state.error}</label>
                                </div>
                            }
                        </Col>
                        {editable &&
                            <Col sm={12}>
                                <Button bsStyle="primary" className="margin-right-10" disabled={this.notOkToSave()} onClick={() => this.toggleModalConfirmation()}>
                                    Save
                            </Button>
                            <Button bsStyle="primary" onClick={this.props.close}>Close</Button>

                            </Col>
                        }

                    </Form>
                </Row>

                <ConfirmationModal showModal={this.state.confirmationModalShow}
                    toggleModal={this.toggleModalConfirmation}
                    confirmationSave={this.actionSaveUserGrants}
                    roleGrants={this.state.prevUserGrants}
                    selectedGrants={this.state.selectedGrants} />

            </NPPanel>
        )
    }
}

export default UserGrants;